import { render, staticRenderFns } from "./OrderPreviewComponent.vue?vue&type=template&id=03fb90c9&"
import script from "./OrderPreviewComponent.vue?vue&type=script&lang=js&"
export * from "./OrderPreviewComponent.vue?vue&type=script&lang=js&"
import style0 from "./OrderPreviewComponent.vue?vue&type=style&index=0&id=03fb90c9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports